var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef, useCallback, createElement, forwardRef, } from "react";
import { flushSync } from "react-dom";
import { useStream } from "./StreamContext";
var PixelStream = forwardRef(function (props, ref) {
    return createElement("pixel-stream", __assign(__assign({}, props), { ref: ref }));
});
var INTERLUCENT_TOKEN = "eyJhbGciOiJFZERTQSIsInR5cCI6IkpXVCIsImtpZCI6ImFub24tMmJmMDg1YTYtYWJlNi00NmY5LTgzMzEtN2JkMzI3ZTc2Y2QyLWk1TSJ9.eyJleHAiOjIxMDM1NDc0MDIsImF1ZCI6ImEiLCJ0eXAiOiJhZG0iLCJhcHIiOnsiYSI6IjQ2NzhhNWMxLTkyMTAtNDY0Mi1hNTY3LTgyZjU2NGM1ZjRhYyIsInYiOiJabnMifX0.2_WRWbLQ6ixedVIVh8jnpgyMhT74WHjf0sMx57vz154FjQO1sY7F-nTkrnjp5Hb03MWchxESq3e2-2DVzhWDCQ";
var STREAM_RATIO = 16 / 9;
export default function InterlucentPlayer() {
    var _this = this;
    var ref = useRef(null);
    var videoRef = useRef(null);
    var _a = useStream(), setStatus = _a.setStatus, setPlayer = _a.setPlayer, setMessage = _a.setMessage, status = _a.status, sendMessage = _a.sendMessage, setVideoOffset = _a.setVideoOffset, player = _a.player, registerConnect = _a.registerConnect;
    // ========================
    // VIDEO DIMENSIONS
    // ========================
    // Dans InterlucentPlayer.tsx
    var updateVideoDimensions = useCallback(function () {
        var _a, _b;
        var ps = ref.current;
        if (!ps)
            return;
        var video = (_b = (_a = ps.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector("video")) !== null && _b !== void 0 ? _b : ps.querySelector("video");
        if (video && video !== videoRef.current) {
            videoRef.current = video;
        }
        if (!videoRef.current)
            return;
        var rect = ps.getBoundingClientRect();
        var width = rect.width;
        var height = rect.height;
        if (!width || !height)
            return;
        var ratio = width / height;
        var v = videoRef.current;
        Object.assign(v.style, {
            position: "absolute",
            objectFit: "fill",
        });
        var offsetX = 0;
        var offsetY = 0;
        var videoWidth = width;
        var videoHeight = height;
        if (ratio > STREAM_RATIO) {
            var h = width * 9 / 16;
            var newHeight = (h * 100 / height);
            var offsetPercent = (100 - newHeight) / 2;
            offsetY = (height * offsetPercent) / 100;
            videoHeight = h;
            v.style.height = "".concat(newHeight, "%");
            v.style.width = "100%";
            v.style.top = "".concat(offsetPercent, "%");
            v.style.left = "0";
        }
        else {
            var w = height * 16 / 9;
            var newWidth = (w * 100 / width);
            var offsetPercent = (100 - newWidth) / 2;
            offsetX = (width * offsetPercent) / 100;
            videoWidth = w;
            v.style.width = "".concat(newWidth, "%");
            v.style.height = "100%";
            v.style.top = "0";
            v.style.left = "".concat(offsetPercent, "%");
        }
        setVideoOffset({
            x: rect.left + offsetX,
            y: rect.top + offsetY,
            width: videoWidth,
            height: videoHeight,
        });
    }, []);
    useEffect(function () {
        window.addEventListener("resize", updateVideoDimensions);
        return function () { return window.removeEventListener("resize", updateVideoDimensions); };
    }, [updateVideoDimensions]);
    // ========================
    // WHEEL SCROLL (COMMENTED)
    // ========================
    /* useEffect(() => {
      const handleWheel = (e: WheelEvent) => {
        const value = e.deltaY > 0 ? 10 : -10;
        sendMessage({
          functionName: "Wheel",
          objName: "",
          parameters: [value * 20],
        });
      };
  
      window.addEventListener("wheel", handleWheel, { passive: true });
      return () => window.removeEventListener("wheel", handleWheel);
    }, [sendMessage]); */
    // ========================
    // PLAYER SETUP
    // ========================
    useEffect(function () {
        var setup = function () { return __awaiter(_this, void 0, void 0, function () {
            var ps, onDataChannelOpen, onReady, onStatusChange, onMessage, onError;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        console.log("[InterlucentPlayer] setup() appelé");
                        console.log("[InterlucentPlayer] attente customElements.whenDefined('pixel-stream')...");
                        return [4 /*yield*/, customElements.whenDefined("pixel-stream")];
                    case 1:
                        _a.sent();
                        console.log("[InterlucentPlayer] customElements 'pixel-stream' défini !");
                        ps = ref.current;
                        if (!ps) {
                            console.error("[InterlucentPlayer] ref.current est null après whenDefined !");
                            return [2 /*return*/];
                        }
                        setPlayer(ps);
                        updateVideoDimensions();
                        registerConnect(function () {
                            console.log("[InterlucentPlayer] connect() → assignation token + play()");
                            ps.admissionToken = INTERLUCENT_TOKEN;
                            ps.play();
                        });
                        console.log("[InterlucentPlayer] Player initialisé, connect enregistré");
                        onDataChannelOpen = function () {
                            console.log("[InterlucentPlayer] EVENT: data-channel-open");
                            updateVideoDimensions();
                        };
                        onReady = function () {
                            console.log("[InterlucentPlayer] EVENT: ready");
                            updateVideoDimensions();
                        };
                        onStatusChange = function (e) {
                            var _a, _b;
                            var newStatus = (_b = (_a = e.detail) === null || _a === void 0 ? void 0 : _a.newStatus) !== null && _b !== void 0 ? _b : "idle";
                            console.log("[InterlucentPlayer] EVENT: status-change →", newStatus, e.detail);
                            setStatus(newStatus);
                            requestAnimationFrame(updateVideoDimensions);
                        };
                        onMessage = function (e) {
                            // flushSync empêche React 18 de batcher des messages consécutifs :
                            // sans ça, plusieurs messages dans le même tick fusionnent et showLabelName peut être perdu
                            flushSync(function () {
                                setMessage(typeof e.detail === "string" ? e.detail : __assign({}, e.detail));
                            });
                        };
                        onError = function (e) {
                            console.error("[InterlucentPlayer] EVENT ERREUR:", e.type, e.detail);
                            setStatus("failed");
                        };
                        // Attach listeners
                        ps.addEventListener("data-channel-open", onDataChannelOpen);
                        ps.addEventListener("ready", onReady);
                        ps.addEventListener("status-change", onStatusChange);
                        ps.addEventListener("ue-command-response", onMessage);
                        ps.addEventListener("session-error", onError);
                        ps.addEventListener("admission-error", onError);
                        console.log("[InterlucentPlayer] Tous les listeners attachés");
                        return [2 /*return*/, function () {
                                ps.removeEventListener("data-channel-open", onDataChannelOpen);
                                ps.removeEventListener("ready", onReady);
                                ps.removeEventListener("status-change", onStatusChange);
                                ps.removeEventListener("ue-command-response", onMessage);
                                ps.removeEventListener("session-error", onError);
                                ps.removeEventListener("admission-error", onError);
                            }];
                }
            });
        }); };
        var scriptId = "interlucent-script";
        var existing = document.getElementById(scriptId);
        console.log("[InterlucentPlayer] Script existant ?", !!existing);
        if (!existing) {
            var script = document.createElement("script");
            script.id = scriptId;
            script.src =
                "https://cdn.interlucent.ai/dev/pixel-stream/0.0.73/pixel-stream.iife.min.js";
            console.log("[InterlucentPlayer] Chargement du script CDN:", script.src);
            script.onload = function () {
                console.log("[InterlucentPlayer] Script CDN chargé avec succès");
                setup();
            };
            script.onerror = function (err) {
                console.error("[InterlucentPlayer] ECHEC chargement script CDN !", err);
                setStatus("failed");
            };
            document.body.appendChild(script);
        }
        else {
            console.log("[InterlucentPlayer] Script déjà présent, pixel-stream défini ?", !!customElements.get("pixel-stream"));
            if (customElements.get("pixel-stream")) {
                setup();
            }
            else {
                existing.addEventListener("load", setup, { once: true });
            }
        }
    }, [updateVideoDimensions]);
    // ========================
    // ACTIONS
    // ========================
    var launch = function () {
        var ps = ref.current;
        if (ps === null || ps === void 0 ? void 0 : ps.play) {
            ps.play();
        }
    };
    var cancel = function () {
        var ps = ref.current;
        if (ps === null || ps === void 0 ? void 0 : ps.cancel) {
            ps.cancel();
        }
    };
    // ========================
    // RENDER
    // ========================
    return (_jsx("div", __assign({ style: {
            position: "fixed",
            inset: 0,
        } }, { children: _jsx(PixelStream, __assign({ ref: ref, style: {
                width: "100%",
                height: "100%",
                display: "block",
            } }, { children: _jsx("div", { slot: "overlay", style: {
                    pointerEvents: "none",
                    width: "0px",
                    height: "0px",
                    overflow: "hidden",
                    opacity: 0,
                } }) })) })));
}
